const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getSendRecords({ rootState }, params = {}) {
      const data = await rootState.http("/opUserAccount/tempkey/querySendRecords", params);
      return data;
    },
    async sentApply({ rootState }, params = {}) {
      const data = await rootState.http("/opUserAccount/tempkey/send", params);
      return data;
    },
    async syncStatusApi({ rootState }, params = {}) {
      const data = await rootState.http("/opParts/sync", params);
      return data;
    },
    async saveTenant({ rootState }, params = {}) {
      const data = await rootState.http("/tenant/saveTenant", params);
      return data;
    },
    async getSettleMethodList({ rootState }, params = {}) {
      const data = await rootState.http("/supplier/getBalanceWay", params);
      return data;
    },
    async getTenantList({ rootState }, params = {}) {
      const data = await rootState.http("/tenant/queryTenantList", params);
      return data;
    },
    async getTenantDetail({ rootState }, params = {}) {
      const data = await rootState.http("/tenant/getTenant", params);
      return data;
    },
    async queryApplyListV2({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/queryStoreApplyList/v2", params);
      return data;
    },
    async getStoreInfo({ rootState }, params = {}) {
      const data = await rootState.http("/op/store/getOpStore", params);
      return data;
    },
    async getApplyInfo({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/getStoreApply", params);
      return data;
    },
    async createStore({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/createStore", params);
      return data;
    },
    async createStoreByTmall({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/openTmall", params);
      return data;
    },
    async getStoreList({ rootState }, params = {}) {
      const data = await rootState.http("/op/store/queryOpStore", params);
      return data;
    },
    async updateEnableStore({ rootState }, params = {}) {
      const data = await rootState.http("/op/store/enableStore", params);
      return data;
    },
    async updateDisableStore({ rootState }, params = {}) {
      const data = await rootState.http("/op/store/disableStore", params);
      return data;
    },
    async queryStoreCode({ rootState }, params = {}) {
      const data = await rootState.http("/op/store/exist", params, {
        errorMessage: false
      });
      return data;
    },
    async updateSignupStatus({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/signedStore", params);
      return data;
    },
    async updateTmallCheck({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/tmallVerify", params);
      return data;
    },
    async getViewContractUrl({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/viewContract", params);
      return data;
    },
    async updateStoreApply({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/modifyStoreApply", params);
      return data;
    },
    async applyResign({ rootState }, params = {}) {
      const data = await rootState.http("storeApply/eSignResign", params);
      return data;
    },
    async cancelSign({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/eSignRevoke", params);
      return data;
    },
    async resendPhoneMessage({ rootState }, params = {}) {
      const data = await rootState.http("/op/store/resendInitStoreSms", params);
      return data;
    },
    async createStoreNotGiti({ rootState }, params = {}) {
      const data = await rootState.http("/op/store/createStore", params);
      return data;
    },
    async queryTmallChangeList({ rootState }, params = {}) {
      const data = await rootState.http("/opTmallInfo/queryTmallInfoModifyRecordPage", params);
      return data;
    },
    async queryTmallChangeDiffDetail({ rootState }, params = {}) {
      const data = await rootState.http("/opTmallInfo/getTmallInfoModifyRecord", params);
      return data;
    },
    async updateTmallChangeCheckResult({ rootState }, params = {}) {
      const data = await rootState.http("/opTmallInfo/auditTmallInfo", params);
      return data;
    },
    async queyrStoreContactList({ rootState }, params = {}) {
      const data = await rootState.http("/esign/opContract/queryContractList", params);
      return data;
    },
    async queryViewContractUrlV2({ rootState }, params = {}) {
      const data = await rootState.http("/store/viewContract/v2", params);
      return data;
    },
    async insertRenewSend({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/issueRenewalContract", params);
      return data;
    },
    async queryPrevRenewFailureList({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/queryLastIssueFailureRecord", params);
      return data;
    },
    async queryContractTmepList({ rootState }, params = {}) {
      const data = await rootState.http("/esign/contract/queryTemplateList", params);
      return data;
    },
    async insertTmallUrge({ rootState }, params = {}) {
      const data = await rootState.http("/storeApply/eSignRushsign", params);
      return data;
    }
  }
};

export default store;
